export const COLUMNS = [
  {
    headerName: "Mã lớp thi",
    field: "examClassId",
    width: 100,
  },
  {
    headerName: "Mã lớp học",
    field: "classId",
    width: 100,
  },
  {
    headerName: "Mã học phần",
    field: "courseId",
    width: 120,
  },
  {
    headerName: "Ghi chú",
    field: "description",
    width: 300,
  },
  {
    headerName: "Tên học phần",
    field: "courseName",
    width: 300,
  },
  {
    headerName: "Nhóm",
    field: "groupId",
    width: 70,
  },
  {
    headerName: "SL SV",
    field: "numberOfStudents",
    width: 70,
  },
  {
    headerName: "Trường/Khoa",
    field: "school",
    width: 300,
  },
  {
    headerName: "Đợt",
    field: "period",
    width: 50,
  },
  {
    headerName: "Mã quản lý",
    field: "managementCode",
    width: 100,
  },
];
